import block from "bem-css-modules";

import s from './TextInput.module.scss';
import {useController} from "react-hook-form";
import {useTranslation} from "react-i18next";

const b = block(s);
const TextInput = ({control, name, type='text', className}) => {
    const {
        field: {onChange, onBlur},
        fieldState: {error},
    } = useController({
        name,
        control,
        rules: {required: true},
    })
    const invalid = error?.type !== undefined;
    const {t} = useTranslation('common');

    return <div className={className}>
        <div className={b('wrapper', {invalid})}>
            <input
                type={type}
                placeholder={t(name)}
                onBlur={onBlur}
                name={name}
                id={`field-${name}`}
                onChange={onChange}
                className={b('input', {invalid})}/>
            <label className={b('label', {invalid})} htmlFor={`field-${name}`}>{t(name)}</label>
        </div>
        <span className={b('error', {invalid})}>{invalid ? error?.message : ""}</span>
    </div>
}

export default TextInput
